import {useEffect, useState} from 'react'

import defer from 'lodash/defer'

const useMemoDeferred = <T>(factory: () => T, deps: unknown[], getInitialValue: () => T) => {
  const [value, setValue] = useState<T>(getInitialValue)

  useEffect(() => {
    defer(() => setValue(factory()))
  }, deps)

  return value
}

export default useMemoDeferred
